import { motion } from 'framer-motion'
import { Link, useNavigate } from 'react-router-dom'
import { Users, Briefcase } from 'lucide-react'
import { Card, CardContent } from '../components/ui/card'
import { Button } from '../components/ui/button'
import { BrandMark } from '../components/BrandMark'
import { ThemeToggle } from '../components/ThemeToggle'
import { useSession, signOut } from '@/lib/auth-client'

const Entry = () => {
  const { data: session } = useSession()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center px-4">
      <div className="absolute top-4 right-4 flex items-center gap-3">
        {session ? (
          <>
            <span className="text-sm text-muted-foreground">{session.user.name}</span>
            <Button variant="outline" size="sm" onClick={() => signOut()}>
              Sign out
            </Button>
          </>
        ) : (
          <Button variant="outline" size="sm" onClick={() => navigate('/login')}>
            Sign in
          </Button>
        )}
        <ThemeToggle />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl w-full text-center"
      >
        <BrandMark size="lg" className="justify-center mb-8" />

        <h1 className="text-3xl sm:text-5xl font-bold text-foreground mb-4">Welcome</h1>
        <p className="text-lg text-muted-foreground mb-10">Choose how you want to use Bookmi today.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Link to="/customer" className="group">
            <Card className="h-full p-8 text-left transition-all hover:shadow-md hover:ring-foreground/20">
              <CardContent className="px-0">
                <div className="w-12 h-12 rounded-xl bg-primary/15 text-primary flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
                  <Users className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">I’m a Customer</h3>
                <p className="text-muted-foreground">Search, filter, and discover local services near you.</p>
              </CardContent>
            </Card>
          </Link>

          <Link to="/provider" className="group">
            <Card className="h-full p-8 text-left transition-all hover:shadow-md hover:ring-foreground/20">
              <CardContent className="px-0">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
                  <Briefcase className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">I’m a Provider</h3>
                <p className="text-muted-foreground">Manage your services, details, and bookings.</p>
              </CardContent>
            </Card>
          </Link>
        </div>
      </motion.div>
    </div>
  )
}

export default Entry
